export default __webpack_public_path__ + "static/media/0003075.be4ae9af.mp3";